var config = {
  mpmEnv: import.meta.env.MPM_ENV,
  mpmBackendUrl: import.meta.env.MPM_BACKEND_URL
};
export { config };